export default __webpack_public_path__ + "static/media/plus-circle.7a23ed26.svg";